<!--
 * @Author: cgh
 * @Date: 2022-07-21
 * @LastEditors: DQL
 * @LastEditTime: 2022-09-20 10:16:45
 * @Description: 查看维保合同
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-60 o-dialog--xl-50"
    title="签到图片"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <div class="o-qd">
      <image-preview
        v-for="(item,index) in fd.images"
        :key="`签到图片${index}`"
        class="o-qd__img"
        :value="item"
        fit="fit"
      />
    </div>
    <!--
    <image-upload-list
      v-model="fd.images"
      multiple
      disabled
      list-type="picture-card"
    /> -->
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <el-button
        @click="closeDialog()"
      >
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'QdxxViewDialog',
  props: {
    dlParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      dialogShow: true, // 模态框dialog显示
      loading: false, // 页面是否加载
      fd: {
        id: null,
        images: []
      }
    };
  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    }
  },
  created () {
    if (this.dlParams.jzFileId) {
      this.fd.images.push(this.dlParams.jzFileId);
    }
    if (this.dlParams.brFileId) {
      this.fd.images.push(this.dlParams.brFileId);
    }
  }
};

</script>
<style lang="scss">
.o-qd {
  display: flex;
  align-content: stretch;
  height: 100%;
}

.o-qd__img {
  width: 100%;
  min-height: 230px;

  & + .o-qd__img{
    margin-left: 10px;
  }
}
</style>
